var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupermarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/supermarket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/supermarket",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DEDFE1",
    points: "7 52 73 52 73 26 7 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "6.9999 39.0008 6.9999 52.0008 44.9999 52.0008 61.9999 35.0008 17.9999 26.0008"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#E04622",
    points: "18 35 62 35 62 23 18 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#313036",
    points: "18 52 62 52 62 35 18 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#D9CA45",
    points: "42.2295 16.0004 40.0985 17.0924 37.9675 16.0004 36.6665 18.0114 34.2755 18.1314 34.1555 20.5234 32.1435 21.8224 33.2355 23.9544 32.1435 26.0864 34.1555 27.3864 34.2755 29.7774 36.6665 29.8984 37.9675 31.9084 40.0985 30.8174 42.2295 31.9084 43.5295 29.8984 45.9215 29.7774 46.0405 27.3864 48.0525 26.0864 46.9605 23.9544 48.0525 21.8224 46.0405 20.5234 45.9215 18.1314 43.5295 18.0114"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#51C25D",
    points: "1.9998 0.0002 -0.0002 5.0002 -0.0002 9.0002 22.9998 9.0002 22.9998 5.0002 16.9998 4.0012 12.9998 0.0002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9999,9.0004 C5.9999,10.1044 5.1039,11.0004 3.9999,11.0004 C2.8959,11.0004 1.9999,10.1044 1.9999,9.0004 C1.9999,7.8964 2.8959,7.0004 3.9999,7.0004 C5.1039,7.0004 5.9999,7.8964 5.9999,9.0004",
    id: "Fill-7",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999,9.0004 C19.9999,10.1044 19.1039,11.0004 17.9999,11.0004 C16.8959,11.0004 15.9999,10.1044 15.9999,9.0004 C15.9999,7.8964 16.8959,7.0004 17.9999,7.0004 C19.1039,7.0004 19.9999,7.8964 19.9999,9.0004",
    id: "Fill-10",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9999,0.0004 L12.9999,0.0004 L16.9999,4.0004 L4.9999,4.0004 C3.8959,4.0004 2.9999,3.1044 2.9999,2.0004 L2.9999,0.0004 Z",
    id: "Fill-21",
    fill: "#010202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(51.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#00ABE3",
    points: "5.9999 4.0004 9.9999 0.0004 20.9999 0.0004 22.9999 5.0004 22.9999 9.0004 -0.0001 9.0004 -0.0001 5.0004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999,9.0004 C16.9999,10.1044 17.8959,11.0004 18.9999,11.0004 C20.1049,11.0004 20.9999,10.1044 20.9999,9.0004 C20.9999,7.8964 20.1049,7.0004 18.9999,7.0004 C17.8959,7.0004 16.9999,7.8964 16.9999,9.0004",
    id: "Fill-15",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9999,9.0004 C2.9999,10.1044 3.8959,11.0004 4.9999,11.0004 C6.1039,11.0004 6.9999,10.1044 6.9999,9.0004 C6.9999,7.8964 6.1039,7.0004 4.9999,7.0004 C3.8959,7.0004 2.9999,7.8964 2.9999,9.0004",
    id: "Fill-18",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999,0.0004 L9.9999,0.0004 L5.9999,4.0004 L17.9999,4.0004 C19.1039,4.0004 19.9999,3.1044 19.9999,2.0004 L19.9999,0.0004 Z",
    id: "Fill-23",
    fill: "#010202"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarket);
export default __webpack_public_path__ + "static/media/supermarket.ec99bd4934eb0db4f69281bec0378178.svg";
export { ForwardRef as ReactComponent };